//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: null
    },
    text11: {
      type: String,
      default: null
    },
    text12: {
      type: String,
      default: null
    },
    text2: {
      type: String,
      default: null
    },
    text3: {
      type: String,
      default: null
    }
  }
}
